// You can use the export_most_listened_by_kinkiness_to_json rake task on the api project to regenerate this JSON file
// Make sure that no bucket is too small in the file, it it is, talk with Tessa.
import mostListenedStoriesByKinkiness from 'components/NewExplorePage/AudioOfTheDay/most_listened_by_kinkiness.json';

import { ContentType as OnboardingContentType } from 'containers/Onboarding/types';

import { ContentType } from 'types/contentType';

export enum Environment {
  Production,
  Staging,
}

enum Genres {
  Affirmations,
}

export enum LanguageIntensities {
  Soft,
  Intense,
  Rough,
}

enum Tags {
  Meditations,
  LoveLetters,
  Affirmations,
  LGBTQIA,
  Gay,
  Lesbian,
  BiPansexual,
  Transgender,
  Queer,
}

enum AudioCourse {
  Audios,
  Recommendations,
}

const GENRES: Record<Genres, Record<Environment, string>> = {
  [Genres.Affirmations]: {
    [Environment.Production]: '9',
    [Environment.Staging]: '12',
  },
};

interface SexualAnxietyClass {
  [AudioCourse.Audios]: {
    [locale: string]: {
      [environment: string]: string[];
    };
  };
  [AudioCourse.Recommendations]: {
    [locale: string]: {
      [environment: string]: string[];
    };
  };
}

const SEXUAL_ANXIETY_CLASS: SexualAnxietyClass = {
  [AudioCourse.Audios]: {
    de: {
      [Environment.Staging]: ['16', '201', '202', '203', '204', '205'],
      [Environment.Production]: ['3588', '3619', '3620', '3621', '3622'],
    },
    'fr-FR': {
      [Environment.Staging]: ['206', '207', '208', '209', '210'],
      [Environment.Production]: ['3587', '3615', '3616', '3617', '3618'],
    },
    'en-GB': {
      [Environment.Staging]: [],
      [Environment.Production]: [],
    },
    'en-US': {
      [Environment.Staging]: [],
      [Environment.Production]: [],
    },
  },
  [AudioCourse.Recommendations]: {
    de: {
      [Environment.Staging]: ['250', '251', '254'],
      [Environment.Production]: [
        '103555',
        '103556',
        '103557',
        '103558',
        '103559',
      ],
    },
    'fr-FR': {
      [Environment.Staging]: ['250', '251', '254'],
      [Environment.Production]: [
        '103549',
        '103550',
        '103552',
        '103553',
        '103554',
      ],
    },
    'en-GB': {
      [Environment.Staging]: [],
      [Environment.Production]: [],
    },
    'en-US': {
      [Environment.Staging]: [],
      [Environment.Production]: [],
    },
  },
};

const TAGS: Record<Tags, Record<Environment, string>> = {
  [Tags.Meditations]: {
    [Environment.Production]: '164',
    [Environment.Staging]: '44',
  },
  [Tags.LoveLetters]: {
    [Environment.Production]: '168',
    [Environment.Staging]: '145',
  },
  [Tags.Affirmations]: {
    [Environment.Production]: '165',
    [Environment.Staging]: '298',
  },
  [Tags.LGBTQIA]: {
    [Environment.Production]: '373',
    [Environment.Staging]: '157',
  },
  [Tags.Gay]: {
    [Environment.Production]: '60',
    [Environment.Staging]: '158',
  },
  [Tags.Lesbian]: {
    [Environment.Production]: '262',
    [Environment.Staging]: '159',
  },
  [Tags.BiPansexual]: {
    [Environment.Production]: '59',
    [Environment.Staging]: '59',
  },
  [Tags.Transgender]: {
    [Environment.Production]: '241',
    [Environment.Staging]: '160',
  },
  [Tags.Queer]: {
    [Environment.Production]: '170',
    [Environment.Staging]: '60',
  },
};

const VISIBLE_GENRE_IDS: Record<Environment, string[]> = {
  [Environment.Production]: ['5', '2'],
  [Environment.Staging]: ['8', '11'],
};

const DEFAULT_ONBOARDING_RECOMMENDED_TAG_IDS: Record<Environment, string[]> = {
  [Environment.Production]: ['3', '10'],
  [Environment.Staging]: ['14', '23'],
};

const DEFAULT_VANILLA_ONBOARDING_TAGS_IDS: Record<Environment, string[]> = {
  [Environment.Production]: [
    '3',
    '377',
    '131',
    '2',
    '257',
    '48',
    '169',
    '11',
    '136',
  ],
  [Environment.Staging]: [
    '122',
    '40',
    '49',
    '72',
    '22',
    '39',
    '78',
    '79',
    '62',
  ],
};

const DEFAULT_SPEAKER_RECOMMENDATIONS_GENRE_IDS: Record<Environment, string[]> =
  {
    [Environment.Production]: ['2', '5', '15'],
    [Environment.Staging]: ['9', '15', '20'],
  };

const CONTENT_TYPE_SOUL: Record<Environment, string[]> = {
  [Environment.Production]: ['9', '12', '13', '14'],
  [Environment.Staging]: ['12'],
};

const CONTENT_TYPE_SEX_SOUNDS: Record<Environment, string[]> = {
  [Environment.Production]: ['3', '6', '10'],
  [Environment.Staging]: ['10', '14'],
};

const CONTENT_TYPE_STORIES: Record<Environment, string[]> = {
  [Environment.Production]: ['2', '5', '15'],
  [Environment.Staging]: ['8', '11'],
};

const USER_GENERATED_CONTENT_SPEAKERS: Record<Environment, string[]> = {
  [Environment.Staging]: ['65', '66', '67', '68', '69'],
  [Environment.Production]: [
    '162',
    '163',
    '164',
    '165',
    '166',
    '167',
    '168',
    '169',
    '170',
    '171',
    '172',
    '173',
    '174',
    '175',
    '176',
    '177',
    '178',
    '179',
    '180',
    '181',
    '182',
    '183',
    '184',
    '185',
  ],
};

const STORIES_TO_EXCLUDE_FROM_360_BROWSE_PAGE: Record<Environment, string[]> = {
  [Environment.Staging]: ['991', '992'],
  [Environment.Production]: ['2620', '2817'],
};

const MATOMO_CUSTOM_DIMENSIONS: Record<Environment, Record<string, number>> = {
  [Environment.Staging]: {
    progressiveWebAppStandalone: 1,
    splitTestNameAndGroup: 3,
  },
  [Environment.Production]: {
    progressiveWebAppStandalone: 2,
    splitTestNameAndGroup: 4,
  },
};

type SearchSuggestionsType = 'speakers' | 'tags';
export type Locale = 'de' | 'fr-FR' | 'en-GB' | 'en-US';

const SEARCH_SUGGESTIONS: Record<
  Environment,
  Record<Locale, Record<SearchSuggestionsType, string[]>>
> = {
  [Environment.Staging]: {
    de: { speakers: ['65', '12'], tags: ['23', '14'] },
    'fr-FR': { speakers: ['65', '12'], tags: ['23', '14'] },
    'en-GB': { speakers: ['65', '12'], tags: ['23', '14'] },
    'en-US': { speakers: ['65', '12'], tags: ['23', '14'] },
  },
  [Environment.Production]: {
    de: { speakers: ['9', '46', '31'], tags: ['131', '136', '3'] },
    'fr-FR': { speakers: ['46', '132', '142'], tags: ['3', '131'] },
    'en-US': { speakers: ['59', '46', '102'], tags: ['131', '100', '136'] },
    'en-GB': { speakers: ['59', '46', '102'], tags: ['131', '100', '136'] },
  },
};

const TOP_VOICES_SPEAKER_IDS: Record<Environment, Record<Locale, string[]>> = {
  [Environment.Staging]: {
    de: ['3', '2', '5', '12', '59', '57'],
    'fr-FR': ['3', '2', '5', '12', '59', '57'],
    'en-GB': ['3', '2', '5', '12', '59', '57'],
    'en-US': ['3', '2', '5', '12', '59', '57'],
  },
  [Environment.Production]: {
    de: ['14', '52', '34', '28', '37', '214'],
    'fr-FR': ['142', '144', '139', '145', '140', '204'],
    'en-GB': ['128', '123', '104', '102', '100', '190'],
    'en-US': ['128', '123', '104', '102', '100', '190'],
  },
};

const POPULAR_SEARCHES: Record<Environment, Record<Locale, string[]>> = {
  [Environment.Staging]: {
    de: ['114', '48', '123', '23'],
    'fr-FR': ['114', '48', '123', '23'],
    'en-GB': ['114', '48', '123', '23'],
    'en-US': ['114', '48', '123', '23'],
  },
  [Environment.Production]: {
    de: ['114', '48', '328', '123'],
    'fr-FR': ['114', '48', '328', '123'],
    'en-US': ['114', '48', '328', '123'],
    'en-GB': ['114', '48', '328', '123'],
  },
};

const FANTASIES_SOUNDS: Record<Environment, Record<Locale, string[]>> = {
  [Environment.Staging]: {
    de: ['131', '117', '100', '13', '23', '155'],
    'fr-FR': ['131', '117', '100', '13', '23', '155'],
    'en-GB': ['131', '117', '100', '13', '23', '155'],
    'en-US': ['131', '117', '100', '13', '23', '155'],
  },
  [Environment.Production]: {
    de: ['131', '169', '49', '136', '2', '161', '234', '349', '350'],
    'fr-FR': ['131', '169', '49', '136', '2', '161', '234', '349', '350'],
    'en-US': ['131', '169', '49', '136', '2', '161', '350'],
    'en-GB': ['131', '169', '49', '136', '2', '161', '350'],
  },
};

const SCENARIOS_SOUNDS: Record<Environment, Record<Locale, string[]>> = {
  [Environment.Staging]: {
    de: ['38', '149', '42', '61', '151', '152', '123', '154'],
    'fr-FR': ['38', '149', '42', '61', '151', '152', '123', '154'],
    'en-GB': ['38', '149', '42', '61', '151', '152', '123', '154'],
    'en-US': ['38', '149', '42', '61', '151', '152', '123', '154'],
  },
  [Environment.Production]: {
    de: ['328', '347', '348', '11', '123'],
    'fr-FR': ['328', '347', '348', '11', '123'],
    'en-US': ['328', '347', '348', '11', '123'],
    'en-GB': ['328', '347', '348', '11', '123'],
  },
};

const SCENARIO_TAG_IDS = {
  [Environment.Production]: {
    solo: ['348', '347'],
    couples: ['124', '123', '328'],
    threesomes: ['352', '335'],
    groups: ['333', '7'],
  },
  [Environment.Staging]: {
    solo: ['17', '13'],
    couples: ['16', '14'],
    threesomes: ['18', '20'],
    groups: ['12'],
  },
};

const QUEER_TAG_IDS: Record<Environment, string[]> = {
  [Environment.Staging]: ['60'],
  [Environment.Production]: ['170'],
};

const PROMOTED_QUEER_AUDIOS: Record<Environment, Record<Locale, string[]>> = {
  [Environment.Staging]: {
    de: ['1043'],
    'fr-FR': ['830'],
    'en-GB': [],
    'en-US': [],
  },
  [Environment.Production]: {
    de: ['2620'],
    'fr-FR': ['2624'],
    'en-GB': [],
    'en-US': [],
  },
};

const PROMOTED_NON_QUEER_AUDIOS: Record<
  Environment,
  Record<Locale, string[]>
> = {
  [Environment.Staging]: {
    de: ['604'],
    'fr-FR': ['1743'],
    'en-GB': [],
    'en-US': [],
  },
  [Environment.Production]: {
    de: ['2817'],
    'fr-FR': ['2816'],
    'en-GB': [],
    'en-US': [],
  },
};

const CONTENT_TYPE_IDS = {
  [Environment.Staging]: {
    [ContentType.Soul]: '1',
    [ContentType.Sounds]: '2',
    [ContentType.Story]: '3',
    [ContentType.Series]: '4',
  },
  [Environment.Production]: {
    [ContentType.Soul]: '1',
    [ContentType.Sounds]: '2',
    [ContentType.Story]: '3',
    [ContentType.Series]: '4',
  },
};

const EXPLORE_PAGE_TAGS_ORDER = {
  [Environment.Production]: {
    tagIds: ['257', '136', '131', '350', '151'],
  },
  [Environment.Staging]: {
    tagIds: ['31', '50', '13'],
  },
};

const SOFT_KINKS_TAG_IDS = ['354', '355', '343', '341'];
const MEDIUM_KINKS_TAG_IDS = ['341', '354', '342', '337'];
const HARD_KINKS_TAG_IDS = ['341', '356', '342', '337'];

const MOODS_BASED_ON_KINKS = {
  [Environment.Production]: {
    1: SOFT_KINKS_TAG_IDS,
    2: SOFT_KINKS_TAG_IDS,
    3: MEDIUM_KINKS_TAG_IDS,
    4: MEDIUM_KINKS_TAG_IDS,
    5: HARD_KINKS_TAG_IDS,
  },
  [Environment.Staging]: {
    1: ['51', '136'],
    2: ['137', '138'],
    3: ['139', '140'],
    4: ['141', '142'],
    5: ['143'],
  },
};

const MOST_LISTENED_BY_KINKINESS = {
  [Environment.Production]: mostListenedStoriesByKinkiness,
  [Environment.Staging]: {
    '1': { de: [1225], 'en-GB': [1181], 'en-US': [3096], 'fr-FR': [3094] },
    '2': { de: [1225], 'en-GB': [1181], 'en-US': [3096], 'fr-FR': [3094] },
    '3': { de: [1225], 'en-GB': [1181], 'en-US': [3096], 'fr-FR': [3094] },
    '4': { de: [1225], 'en-GB': [1181], 'en-US': [3096], 'fr-FR': [3094] },
    '5': { de: [1225], 'en-GB': [1181], 'en-US': [3096], 'fr-FR': [3094] },
  },
};

const defaultGetKinkierTags = {
  0: ['100', '253', '386'],
  1: ['61', '63', '253'],
  2: ['29', '7', '183'],
  3: ['86', '263', '184'],
  4: ['333', '302', '185'],
  5: ['357', '69', '189'],
};

const defaultStagingGetKinkierTags = {
  0: ['61', '63', '51'],
  1: ['61', '63', '51'],
  2: ['61', '63', '51'],
  3: ['61', '63', '51'],
  4: ['61', '63', '51'],
  5: ['61', '63', '51'],
};

const GET_KINKIER_TAGS = {
  [Environment.Production]: {
    de: {
      0: ['100', '253', '386'],
      1: ['61', '63', '253'],
      2: ['29', '7', '183'],
      3: ['322', '263', '184'],
      4: ['333', '302', '185'],
      5: ['357', '69', '68'],
    },
    'fr-FR': {
      0: ['100', '253', '386'],
      1: ['61', '258', '253'],
      2: ['29', '7', '188'],
      3: ['322', '263', '184'],
      4: ['333', '302', '185'],
      5: ['357', '353', '163'],
    },
    'en-GB': defaultGetKinkierTags,
    'en-US': defaultGetKinkierTags,
  },
  [Environment.Staging]: {
    de: defaultStagingGetKinkierTags,
    'fr-FR': defaultStagingGetKinkierTags,
    'en-GB': defaultStagingGetKinkierTags,
    'en-US': defaultStagingGetKinkierTags,
  },
};

const SEASONAL_FAVOURITE_IDS = {
  [Environment.Production]: {
    de: ['3109', '2925', '3026', '689'],
    'fr-FR': ['3361', '2926', '2924', '2460'],
    'en-GB': ['3297', '1006', '1729'],
    'en-US': ['3297', '1006', '1729'],
  },
  [Environment.Staging]: {
    de: ['40', '907', '917'],
    'fr-FR': ['40', '907', '917'],
    'en-GB': ['40', '907', '917'],
    'en-US': ['40', '907', '917'],
  },
};

const KINK_OF_THE_MONTH_IDS = {
  [Environment.Production]: {
    de: [
      '258',
      '55',
      '189',
      '95',
      '120',
      '48',
      '161',
      '86',
      '331',
      '100',
      '385',
      '183',
    ],
    'fr-FR': [
      '258',
      '55',
      '189',
      '95',
      '120',
      '48',
      '161',
      '86',
      '331',
      '100',
      '385',
      '183',
    ],
    'en-GB': [
      '258',
      '55',
      '189',
      '95',
      '120',
      '48',
      '161',
      '86',
      '331',
      '100',
      '385',
      '183',
    ],
    'en-US': [
      '258',
      '55',
      '189',
      '95',
      '120',
      '48',
      '161',
      '86',
      '331',
      '100',
      '385',
      '183',
    ],
  },
  [Environment.Staging]: {
    de: [
      '95',
      '164',
      '165',
      '166',
      '167',
      '31',
      '144',
      '168',
      '169',
      '170',
      '1',
      '171',
    ],
    'fr-FR': [
      '95',
      '164',
      '165',
      '166',
      '167',
      '31',
      '144',
      '168',
      '169',
      '170',
      '1',
      '171',
    ],
    'en-GB': [
      '95',
      '164',
      '165',
      '166',
      '167',
      '31',
      '144',
      '168',
      '169',
      '170',
      '1',
      '171',
    ],
    'en-US': [
      '95',
      '164',
      '165',
      '166',
      '167',
      '31',
      '144',
      '168',
      '169',
      '170',
      '1',
      '171',
    ],
  },
};

export const currentEnvironment: () => Environment = () =>
  process.env.IS_PRODUCTION === 'true'
    ? Environment.Production
    : Environment.Staging;

interface IProps {
  locale?: string;
}

const useStaticValues = ({ locale }: IProps = {}) => ({
  contentTypeIds: CONTENT_TYPE_IDS[currentEnvironment()],
  contentTypes: {
    [OnboardingContentType.Soul]: CONTENT_TYPE_SOUL[currentEnvironment()],
    [OnboardingContentType.SexSounds]:
      CONTENT_TYPE_SEX_SOUNDS[currentEnvironment()],
    [OnboardingContentType.Stories]: CONTENT_TYPE_STORIES[currentEnvironment()],
    [OnboardingContentType.SurpriseMe]:
      CONTENT_TYPE_SEX_SOUNDS[currentEnvironment()],
  },
  defaultOnboardingRecommendations: {
    tagIds: DEFAULT_ONBOARDING_RECOMMENDED_TAG_IDS[currentEnvironment()],
  },
  defaultVanillaOnboardingTags: {
    tagIds: DEFAULT_VANILLA_ONBOARDING_TAGS_IDS[currentEnvironment()],
  },
  defaultSpeakerRecommendationsGenres: {
    genreIds: DEFAULT_SPEAKER_RECOMMENDATIONS_GENRE_IDS[currentEnvironment()],
  },
  explorePageTagsOrder: EXPLORE_PAGE_TAGS_ORDER[currentEnvironment()],
  fantasiesSounds: locale
    ? FANTASIES_SOUNDS[currentEnvironment()][locale]
    : FANTASIES_SOUNDS[currentEnvironment()]['de'],
  genreIds: {
    affirmations: GENRES[Genres.Affirmations][currentEnvironment()],
  },
  getKinkierTags: locale
    ? GET_KINKIER_TAGS[currentEnvironment()][locale]
    : GET_KINKIER_TAGS[currentEnvironment()]['de'],
  hiddenSpeakers: [
    '186',
    '187',
    '188',
    '189', // Raphael And Nela
    '192', // "Héloīse & Adam" (FR)
    '193', // "Lia & Emanuel" (DE),
    '195',
    '198', // Compilation
  ],
  kinkOfTheMonthIdsPerLocale: KINK_OF_THE_MONTH_IDS[currentEnvironment()],
  languageIntensities: {
    [LanguageIntensities.Soft]: '1',
    [LanguageIntensities.Intense]: '2',
    [LanguageIntensities.Rough]: '3',
  },
  matomoCustomDimensions: MATOMO_CUSTOM_DIMENSIONS[currentEnvironment()],
  moodsBasedOnKinks: MOODS_BASED_ON_KINKS[currentEnvironment()],
  mostListenedByKinkines: MOST_LISTENED_BY_KINKINESS[currentEnvironment()],
  popularSearches: locale
    ? POPULAR_SEARCHES[currentEnvironment()][locale]
    : POPULAR_SEARCHES[currentEnvironment()]['de'],
  promotedNonQueerAudios: locale
    ? PROMOTED_NON_QUEER_AUDIOS[currentEnvironment()][locale]
    : PROMOTED_NON_QUEER_AUDIOS[currentEnvironment()]['de'],
  promotedQueerAudios: locale
    ? PROMOTED_QUEER_AUDIOS[currentEnvironment()][locale]
    : PROMOTED_QUEER_AUDIOS[currentEnvironment()]['de'],
  queerTagIds: QUEER_TAG_IDS[currentEnvironment()],
  scenarioTagIds: SCENARIO_TAG_IDS[currentEnvironment()],
  scenariosSounds: locale
    ? SCENARIOS_SOUNDS[currentEnvironment()][locale]
    : SCENARIOS_SOUNDS[currentEnvironment()]['de'],
  searchSuggestions: locale
    ? SEARCH_SUGGESTIONS[currentEnvironment()][locale]
    : SEARCH_SUGGESTIONS[currentEnvironment()]['de'],
  seasonalFavouriteIds: locale
    ? SEASONAL_FAVOURITE_IDS[currentEnvironment()][locale]
    : SEASONAL_FAVOURITE_IDS[currentEnvironment()]['de'],
  sexualAnxietyClass: {
    audios:
      SEXUAL_ANXIETY_CLASS[AudioCourse.Audios][locale ?? 'de'][
        currentEnvironment()
      ],
    recommendations:
      SEXUAL_ANXIETY_CLASS[AudioCourse.Recommendations][locale ?? 'de'][
        currentEnvironment()
      ],
  },
  storiesToExcludeFrom360BrowsePage:
    STORIES_TO_EXCLUDE_FROM_360_BROWSE_PAGE[currentEnvironment()],
  tagIds: {
    affirmations: TAGS[Tags.Affirmations][currentEnvironment()],
    loveLetters: TAGS[Tags.LoveLetters][currentEnvironment()],
    meditations: TAGS[Tags.Meditations][currentEnvironment()],
    LGBTQIA: TAGS[Tags.LGBTQIA][currentEnvironment()],
    lesbian: TAGS[Tags.Lesbian][currentEnvironment()],
    gay: TAGS[Tags.Gay][currentEnvironment()],
    biPansexual: TAGS[Tags.BiPansexual][currentEnvironment()],
    transgender: TAGS[Tags.Transgender][currentEnvironment()],
    queer: TAGS[Tags.Queer][currentEnvironment()],
  },
  topVoicesSpeakerIds: locale
    ? TOP_VOICES_SPEAKER_IDS[currentEnvironment()][locale]
    : TOP_VOICES_SPEAKER_IDS[currentEnvironment()]['de'],
  userGeneratedContentSpeakers:
    USER_GENERATED_CONTENT_SPEAKERS[currentEnvironment()],
  visibleGenreIds: VISIBLE_GENRE_IDS[currentEnvironment()],
});

export default useStaticValues;
